module.exports = __webpack_public_path__ + "img/shky.676e6ddc.jpg";